import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { Ads1, Ads2, Ads3, Ads4 } from "scmp-app/pages/topic/styles";
import type { topicCollectionAdsCollection$key } from "scmp-app/queries/__generated__/topicCollectionAdsCollection.graphql";

import { getTopicCollectionAdsConfigs } from "./ads.config";

const adsComponentMap = [Ads1, Ads2, Ads3, Ads4];

export type Props = {
  maxAdsNumber: number;
  reference: topicCollectionAdsCollection$key;
};

export const TopicCollectionAds: FunctionComponent<Props> = ({
  maxAdsNumber,
  reference: reference_,
}) => {
  const data = useFragment(
    graphql`
      fragment topicCollectionAdsCollection on Collection {
        entityId
        advertZone(version: 2)
      }
    `,
    reference_,
  );

  const adsConfigs = getTopicCollectionAdsConfigs(
    data?.entityId ?? undefined,
    data?.advertZone ?? undefined,
  ).slice(0, maxAdsNumber);

  return (
    <>
      {adsConfigs.map((configs, index) => {
        const ComponentType = adsComponentMap[index];

        return (
          <ComponentType key={`AdSlot${index}`}>
            {configs.map(
              (config, configIndex) => config && <AdSlot {...config} key={configIndex} />,
            )}
          </ComponentType>
        );
      })}
    </>
  );
};

TopicCollectionAds.displayName = "TopicCollectionAds";
